// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ie-0";
export var animationContainer = "_ie-1";
export var itemPrice = "_ie-a";
export var itemizedContent = "_ie-9";
export var itemizedHeader = "_ie-7";
export var itemizedRow = "_ie-8";
export var itemizedSection = "_ie-6";
export var modalContent = "_ie-2";
export var orderName = "_ie-3";
export var refundOption = "_ie-4";
export var refundOptionsContainer = "_ie-5";
export var shippingLabel = "_ie-b";
export var totalRow = "_ie-c";